// extracted by mini-css-extract-plugin
export default {"ResetPasssword__gridItem":"ResetPassword_ResetPasssword__gridItem__fKDXC","ResetPasssword":"ResetPassword_ResetPasssword__GQ2H2"};